export const DEFAULT_SUPPORT_EMAIL = import.meta.env.STUUT_SUPPORT_EMAIL || 'support@stuut.co';

export const DEBOUNCE_TIME_MS = Number(import.meta.env.STUUT_DEBOUNCE_TIME_MS || 300);

export const DEFAULT_TABLE_PAGE_SIZE = Number(import.meta.env.STUUT_TABLE_PAGE_SIZE || 20);
export const FEATURE_ENABLE_PARTIAL_PAYMENTS =
  import.meta.env?.STUUT_FEATURE_ENABLE_PARTIAL_PAYMENTS === 'true';

export const FEATURE_ENABLE_INVOICE_AGING_FILTER =
  import.meta.env?.STUUT_FEATURE_ENABLE_INVOICE_AGING_FILTER === 'true';

export enum Priority {
  URGENT = 'urgent',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}
